import type { NewsItem } from "@/types/news";

interface SchemaNewsArticleProps {
	news: NewsItem;
	url: string;
	publishedTime?: string;
}

const BASE_URL = "https://portalcib.online";

const SchemaNewsArticle = ({
	news,
	url,
	publishedTime,
}: SchemaNewsArticleProps) => {
	const fullUrl = `${BASE_URL}${url}`;
	const description = `${news.newsContent.substring(0, 200).replace(/\s+/g, " ").trim()}...`;

	const schema = {
		"@context": "https://schema.org",
		"@type": "NewsArticle",
		url: fullUrl,
		mainEntityOfPage: {
			"@type": "WebPage",
			"@id": fullUrl,
		},
		headline: news.newsTitle.substring(0, 110),
		description,
		image: news.newsImg ? [news.newsImg] : undefined,
		datePublished: publishedTime,
		author: {
			"@type": "Organization",
			name: news.newsAuthor || "Portal CIB",
		},
		publisher: {
			"@type": "Organization",
			name: "Portal CIB - Cadastro Imobiliário Brasileiro",
			logo: {
				"@type": "ImageObject",
				url: `${BASE_URL}/icon-512x512.png`,
				width: 512,
				height: 512,
			},
		},
		isAccessibleForFree: true,
		inLanguage: "pt-BR",
		articleSection: "Notícias",
	};

	return (
		<script
			type="application/ld+json"
			// biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD requires raw JSON
			dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
		/>
	);
};

export default SchemaNewsArticle;
